import {
  BorderRadiusType,
  FullBorderRadiusType,
  PaddingType,
} from 'common/types/styleTypes'
import {
  backgroundColorCss,
  borderRadiusCss,
  mobileBackgroundColorCss,
  mobileBorderRadiusCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import { css, styled } from 'styled-components'
import { FormInterface } from '../form.schema'

export interface FormSuccessOptInScreenContainerUiStylesInterface
  extends Pick<
    FormInterface,
    'padding' | 'mobilePadding' | 'backgroundColor' | 'mobileBackgroundColor'
  > {
  borderRadius?: BorderRadiusType | FullBorderRadiusType
  mobileBorderRadius?: BorderRadiusType | FullBorderRadiusType
}

export const FormSuccessOptInScreenContainerUi = styled.div<FormSuccessOptInScreenContainerUiStylesInterface>`
  flex-shrink: 0;

  ${borderRadiusCss}
  ${paddingsCss}
  ${backgroundColorCss}
  
  ${p => p.theme.phone} {
    ${mobileBorderRadiusCss}
    ${mobilePaddingsCss}
    ${mobileBackgroundColorCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileBorderRadiusCss}
      ${mobilePaddingsCss}
      ${mobileBackgroundColorCss}
  `}
`

export const FormSuccessOptInScreenContainerTopPaddingUi = styled.div`
  flex-shrink: 100;
  flex-basis: 100%;
`

export const FormSuccessOptInScreenContainerBottomPaddingUi = styled.div<{
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
}>`
  flex-shrink: 1;
  ${p => p.padding && `flex-basis: calc(2 * ${p.padding.paddingBottom}px);`}
  
  ${p => p.theme.phone} {
    ${p => p.mobilePadding && `flex-basis: calc(2 * ${p.mobilePadding.paddingBottom}px);`}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${p.mobilePadding && `flex-basis: calc(2 * ${p.mobilePadding.paddingBottom}px);`}
  `}
`
